import { api } from './client';
export async function createInvite(targetUsername) {
    return api('/api/invites', {
        method: 'POST',
        body: JSON.stringify({ targetUsername }),
    });
}
export async function activateInvite(code) {
    await api('/api/invites/activate', {
        method: 'POST',
        body: JSON.stringify({ code }),
    });
}
export async function getMyInvites() {
    return api('/api/invites/my');
}
export async function getInviteTree() {
    return api('/api/invites/tree');
}
